import React, { FC, ReactElement, ReactNode } from 'react';
import { Flex, theme } from '@duxton-web/ui';

export interface IFooterProps {
  footer?: ReactNode;
}

const Footer: FC<IFooterProps> = ({ footer }) => {
  function renderFooter(): ReactElement {
    if (!footer) return null;

    return (
      <Flex
        align="center"
        justify="space-between"
        style={{
          backgroundColor: theme.getDesignToken().white,
          padding: 16,
          borderTop: '1px solid rgb(240, 240, 240)',
        }}
      >
        {footer}
      </Flex>
    );
  }

  return renderFooter();
};

export default Footer;
